import Api from "./api";
import Client from "./client";

export default {
  Api,
  Client
};
